export const deutch = [
  'bisasam',
  'bisanknosp',
  'bisaflor',
  'glumanda',
  'glutexo',
  'glurak',
  'schiggy',
  'schillok',
  'turtok',
  'raupy',
  'safcon',
  'smettbo',
  'hornliu',
  'kokuna',
  'bibor',
  'taubsi',
  'tauboga',
  'tauboss',
  'rattfratz',
  'rattikarl',
  'habitak',
  'ibitak',
  'rettan',
  'arbok',
  'pikachu',
  'raichu',
  'sandan',
  'sandamer',
  'nidoran',
  'nidorina',
  'nidoqueen',
  'nidorino',
  'nidoking',
  'piepi',
  'pixi',
  'vulpix',
  'vulvona',
  'pummeluff',
  'knuddeluff',
  'zubat',
  'golbat',
  'myrapla',
  'duflor',
  'giflor',
  'paras',
  'parasek',
  'bluzuk',
  'omot',
  'digda',
  'digdri',
  'mauzi',
  'snobilikat',
  'enton',
  'entoron',
  'menki',
  'rasaff',
  'fukano',
  'arkani',
  'quapsel',
  'quaputzi',
  'quappo',
  'abra',
  'kadabra',
  'simsala',
  'machollo',
  'maschock',
  'machomei',
  'knofensa',
  'ultigaria',
  'sarzenia',
  'tentacha',
  'tentoxa',
  'kleinstein',
  'georok',
  'geowaz',
  'ponita',
  'gallopa',
  'flegmon',
  'lahmus',
  'magnetilo',
  'magneton',
  'porenta',
  'dodu',
  'dodri',
  'jurob',
  'jugong',
  'sleima',
  'sleimok',
  'muschas',
  'austos',
  'nebulak',
  'alpollo',
  'gengar',
  'onix',
  'traumato',
  'hypno',
  'krabby',
  'kingler',
  'voltobal',
  'lektrobal',
  'owei',
  'kokowei',
  'tragosso',
  'knogga',
  'kicklee',
  'nockchan',
  'schlurp',
  'smogon',
  'smogmog',
  'rihorn',
  'rizeros',
  'chaneira',
  'tangela',
  'kangama',
  'seeper',
  'seemon',
  'goldini',
  'golking',
  'sterndu',
  'starmie',
  'pantimos',
  'sichlor',
  'rossana',
  'elektek',
  'magmar',
  'pinsir',
  'tauros',
  'karpador',
  'garados',
  'lapras',
  'ditto',
  'evoli',
  'aquana',
  'blitza',
  'flamara',
  'porygon',
  'amonitas',
  'amoroso',
  'kabuto',
  'kabutops',
  'aerodactyl',
  'relaxo',
  'arktos',
  'zapdos',
  'lavados',
  'dratini',
  'dragonir',
  'dragoran',
  'mewtu',
  'mew',
  'endivie',
  'lorblatt',
  'meganie',
  'feurigel',
  'igelavar',
  'tornupto',
  'karnimani',
  'tyracroc',
  'impergator',
  'wiesor',
  'wiesenior',
  'hoothoot',
  'noctuh',
  'ledyba',
  'ledian',
  'webarak',
  'ariados',
  'iksbat',
  'lampi',
  'lanturn',
  'pichu',
  'pii',
  'fluffeluff',
  'togepi',
  'togetic',
  'natu',
  'xatu',
  'voltilamm',
  'waaty',
  'ampharos',
  'blubella',
  'marill',
  'azumarill',
  'mogelbaum',
  'quaxo',
  'hoppspross',
  'hubelupf',
  'papungha',
  'griffel',
  'sonnkern',
  'sonnflora',
  'yanma',
  'felino',
  'morlord',
  'psiana',
  'nachtara',
  'kramurx',
  'laschoking',
  'traunfugil',
  'icognito',
  'woingenau',
  'girafarig',
  'tannza',
  'forstellka',
  'dummisel',
  'skorgla',
  'stahlos',
  'snubbull',
  'granbull',
  'baldorfish',
  'scherox',
  'pottrott',
  'skaraborn',
  'sniebel',
  'teddiursa',
  'ursaring',
  'schneckmag',
  'magcargo',
  'quiekel',
  'keifel',
  'corasonn',
  'remoraid',
  'octillery',
  'botogel',
  'mantax',
  'panzaeron',
  'hunduster',
  'hundemon',
  'seedraking',
  'phanpy',
  'donphan',
  'damhirplex',
  'farbeagle',
  'rabauz',
  'kapoera',
  'kussilla',
  'elekid',
  'magby',
  'miltank',
  'heiteira',
  'raikou',
  'entei',
  'suicune',
  'larvitar',
  'pupitar',
  'despotar',
  'lugia',
  'ho-oh',
  'celebi',
  'geckarbor',
  'reptain',
  'gewaldro',
  'flemmli',
  'jungglut',
  'lohgock',
  'hydropi',
  'moorabbel',
  'sumpex',
  'fiffyen',
  'magnayen',
  'zigzachs',
  'geradaks',
  'waumpel',
  'schaloko',
  'papinella',
  'panekon',
  'pudox',
  'loturzel',
  'lombrero',
  'kappalores',
  'samurzel',
  'blanas',
  'tengulist',
  'schwalbini',
  'schwalboss',
  'wingull',
  'pelipper',
  'trasla',
  'kirlia',
  'guardevoir',
  'gehweiher',
  'maskeregen',
  'knilz',
  'kapilz',
  'bummelz',
  'muntier',
  'letarking',
  'nincada',
  'ninjask',
  'ninjatom',
  'flurmel',
  'krakeelo',
  'krawumms',
  'makuhita',
  'hariyama',
  'azurill',
  'nasgnet',
  'eneco',
  'enekoro',
  'zobiris',
  'flunkifer',
  'stollunior',
  'stollrak',
  'stolloss',
  'meditie',
  'meditalis',
  'frizelbliz',
  'voltenso',
  'plusle',
  'minun',
  'volbeat',
  'illumise',
  'roselia',
  'schluppuck',
  'schlukwech',
  'kanivanha',
  'tohaido',
  'wailmer',
  'wailord',
  'camaub',
  'camerupt',
  'qurtel',
  'spoink',
  'groink',
  'pandir',
  'knacklion',
  'vibrava',
  'libelldra',
  'tuska',
  'noktuska',
  'wablu',
  'altaria',
  'sengo',
  'vipitis',
  'lunastein',
  'sonnfel',
  'schmerbe',
  'welsar',
  'krebscorps',
  'krebutack',
  'puppance',
  'lepumentas',
  'liliep',
  'wielie',
  'anorith',
  'armaldo',
  'barschwa',
  'milotic',
  'formeo',
  'kecleon',
  'shuppet',
  'banette',
  'zwirrlicht',
  'zwirrklop',
  'tropius',
  'palimpalim',
  'absol',
  'isso',
  'schneppke',
  'firnontor',
  'seemops',
  'seejong',
  'walraisa',
  'perlu',
  'aalabyss',
  'saganabyss',
  'relicanth',
  'liebiskus',
  'kindwurm',
  'draschel',
  'brutalanda',
  'tanhel',
  'metang',
  'metagross',
  'regirock',
  'regice',
  'registeel',
  'latias',
  'latios',
  'kyogre',
  'groudon',
  'rayquaza',
  'jirachi',
  'deoxys',
  'chelast',
  'chelcarain',
  'chelterrar',
  'panflam',
  'panpyro',
  'panferno',
  'plinfa',
  'pliprin',
  'impoleon',
  'staralili',
  'staravia',
  'staraptor',
  'bidiza',
  'bidifas',
  'zirpurze',
  'zirpeise',
  'sheinux',
  'luxio',
  'luxtra',
  'knospi',
  'roserade',
  'koknodon',
  'rameidon',
  'schilterus',
  'bollterus',
  'burmy',
  'burmadame',
  'moterpel',
  'wadribie',
  'honweisel',
  'pachirisu',
  'bamelin',
  'bojelin',
  'kikugi',
  'kinoso',
  'schalellos',
  'gastrodon',
  'ambidiffel',
  'driftlon',
  'drifzepeli',
  'haspiror',
  'schlapor',
  'traunmagil',
  'kramshef',
  'charmian',
  'shnurgarst',
  'klingplim',
  'skunkapuh',
  'skuntank',
  'bronzel',
  'bronzong',
  'mobai',
  'pantimimi',
  'wonneira',
  'plaudagei',
  'kryppuk',
  'kaumalat',
  'knarksel',
  'knakrack',
  'mampfaxo',
  'riolu',
  'lucario',
  'hippopotas',
  'hippoterus',
  'pionskora',
  'piondragi',
  'glibunkel',
  'toxiquak',
  'venuflibis',
  'finneon',
  'lumineon',
  'mantirps',
  'shnebedeck',
  'rexblisar',
  'snibunna',
  'magnezone',
  'schlurplek',
  'rihornior',
  'tangoloss',
  'elevoltek',
  'magbrant',
  'togekiss',
  'yanmega',
  'folipurba',
  'glaziola',
  'skorgro',
  'mamutel',
  'porygon-z',
  'galagladi',
  'voluminas',
  'zwirrfinst',
  'frosdedje',
  'rotom',
  'selfe',
  'vesprit',
  'tobutz',
  'dialga',
  'palkia',
  'heatran',
  'regigigas',
  'giratina',
  'cresselia',
  'phione',
  'manaphy',
  'darkrai',
  'shaymin',
  'arceus',
  'victini',
  'serpifeu',
  'efoserp',
  'serpiroyal',
  'floink',
  'ferkokel',
  'flambirex',
  'ottaro',
  'zwottronin',
  'admurai',
  'nagelotz',
  'kukmarda',
  'yorkleff',
  'terribark',
  'bissbark',
  'felilou',
  'kleoparda',
  'vegimak',
  'vegichita',
  'grillmak',
  'grillchita',
  'sodamak',
  'sodachita',
  'somniam',
  'somnivora',
  'dusselgurr',
  'navitaub',
  'fasasnob',
  'elezeba',
  'zebritz',
  'kiesling',
  'sedimantur',
  'brockoloss',
  'fleknoil',
  'fletiamo',
  'rotomurf',
  'stalobor',
  'ohrdoch',
  'praktibalk',
  'strepoli',
  'meistagrif',
  'schallquap',
  'mebrana',
  'branawarz',
  'jiutesto',
  'karadonis',
  'strawickl',
  'folikon',
  'matrifol',
  'toxiped',
  'rollum',
  'cerapendra',
  'waumboll',
  'elfun',
  'lilminip',
  'dressella',
  'barschuft',
  'ganovil',
  'rokkaiman',
  'rabigator',
  'flampion',
  'flampivian',
  'maracamba',
  'lithomith',
  'castellith',
  'zurrokex',
  'irokex',
  'symvolara',
  'makabaja',
  'echnatoll',
  'galapaflos',
  'karippas',
  'flapteryx',
  'aeropteryx',
  'unratütox',
  'deponitox',
  'zorua',
  'zoroark',
  'picochilla',
  'chillabell',
  'mollimorba',
  'hypnomorba',
  'morbitesse',
  'monozyto',
  'mitodos',
  'zytomega',
  'piccolente',
  'swaroness',
  'gelatini',
  'gelatroppo',
  'gelatwino',
  'sesokitz',
  'kronjuwild',
  'emolga',
  'laukaps',
  'cavalanzas',
  'tarnpignon',
  'hutsassa',
  'quabbel',
  'apoquallyp',
  'mamolida',
  'wattzapf',
  'voltula',
  'kastadur',
  'tentantel',
  'klikk',
  'kliklak',
  'klikdiklak',
  'zapplardin',
  'zapplalek',
  'zapplarang',
  'pygraulon',
  'megalon',
  'lichtel',
  'laternecto',
  'skelabra',
  'milza',
  'sharfax',
  'maxax',
  'petznief',
  'siberio',
  'frigometri',
  'schnuthelm',
  'hydragil',
  'flunschlik',
  'lin-fu',
  'wie-shu',
  'shardrago',
  'golbit',
  'golgantes',
  'gladiantri',
  'caesurio',
  'bisofank',
  'geronimatz',
  'washakwil',
  'skallyk',
  'grypheldis',
  'furnifraß',
  'fermicula',
  'kapuno',
  'duodino',
  'trikephalo',
  'ignivor',
  'ramoth',
  'kobalium',
  'terrakium',
  'viridium',
  'boreos',
  'voltolos',
  'reshiram',
  'zekrom',
  'demetros',
  'kyurem',
  'keldeo',
  'meloetta',
  'genesect',
  'igamaro',
  'igastarnish',
  'brigaron',
  'fynx',
  'rutena',
  'fennexis',
  'froxy',
  'amphizel',
  'quajutsu',
  'scoppel',
  'grebbit',
  'dartiri',
  'dartignis',
  'fiaro',
  'purmel',
  'puponcho',
  'vivillon',
  'leufeo',
  'pyroleo',
  'flabébé',
  'floette',
  'florges',
  'mähikel',
  'chevrumm',
  'pam-pam',
  'pandagro',
  'coiffwaff',
  'psiau',
  'psiaugon',
  'gramokles',
  'duokles',
  'durengard',
  'parfi',
  'parfinesse',
  'flauschling',
  'sabbaione',
  'iscalar',
  'calamanero',
  'bithora',
  'thanathora',
  'algitt',
  'tandrak',
  'scampisto',
  'wummer',
  'eguana',
  'elezard',
  'balgoras',
  'monargoras',
  'amarino',
  'amagarga',
  'feelinara',
  'resladero',
  'dedenne',
  'rocara',
  'viscora',
  'viscargot',
  'viscogon',
  'clavion',
  'paragoni',
  'trombork',
  'irrbis',
  'pumpdjinn',
  'arktip',
  'arktilas',
  'eF-eM',
  'uHaFnir',
  'xerneas',
  'yvetal',
  'zygarde',
  'diancie',
  'hoopa',
  'volcanion',
  'bauz',
  'arboretoss',
  'silvarro',
  'flamiau',
  'miezunder',
  'fuegro',
  'robball',
  'marikeck',
  'primarene',
  'peppeck',
  'trompeck',
  'tukanon',
  'mangunior',
  'manguspektor',
  'mabula',
  'akkup',
  'donarion',
  'krabbox',
  'krawell',
  'choreogel',
  'wommel',
  'bandelby',
  'wuffels',
  'wolwerock',
  'lusardin',
  'garstella',
  'aggrostella',
  'pampuli',
  'pampross',
  'araqua',
  'aranestro',
  'imantis',
  'mantidea',
  'bubungus',
  'lamellux',
  'molunk',
  'amfira',
  'velursi',
  'kosturso',
  'frubberl',
  'frubaila',
  'fruyal',
  'curelei',
  'kommandutan',
  'quartermak',
  'reißlaus',
  'tectass',
  'sankabuh',
  'colossand',
  'gufa',
  'typ:null',
  'amigento',
  'meteno',
  'koalelu',
  'tortunator',
  'togedemaru',
  'mimigma',
  'knirfish',
  'sen-long',
  'moruda',
  'miniras',
  'mediras',
  'grandiras',
  'kapu-riki',
  'kapu-fala',
  'kapu-toro',
  'kapu-kime',
  'cosmog',
  'cosmovum',
  'solgaleo',
  'lunala',
  'anego',
  'masskito',
  'schabelle',
  'voltriant',
  'kaguron',
  'katagami',
  'schlingking',
  'necrozma',
  'magearna',
  'marshadow',
  'venicro',
  'agoyon',
  'muramura',
  'kopplosio',
  'zeraora',
  'meltan',
  'melmetal',
  'chimpep',
  'chimstix',
  'gortrom',
  'hopplo',
  'kickerlo',
  'liberlo',
  'memmeon',
  'phlegleon',
  'intelleon',
  'raffel',
  'schlaraffel',
  'meikro',
  'kranoviz',
  'krarmor',
  'sensect',
  'keradar',
  'maritellit',
  'kleptifux',
  'gaunux',
  'cottini',
  'cottomi',
  'wolly',
  'zwollock',
  'kamehaps',
  'kamalm',
  'voldi',
  'bellektro',
  'klonkett',
  'wagong',
  'montecarbo',
  'knapfel',
  'drapfel',
  'schlapfel',
  'salanga',
  'sanaconda',
  'urgl',
  'pikuda',
  'barrakiefa',
  'toxel',
  'riffex',
  'thermopod',
  'infernopod',
  'klopptopus',
  'kaocto',
  'fatalitee',
  'mortipot',
  'brimova',
  'brimano',
  'silembrim',
  'bähmon',
  'pelzebub',
  'olangaar',
  'barrikadax',
  'mauzinger',
  'gorgasonn',
  'lauchzelot',
  'pantifrost',
  'oghnatoll',
  'hokumil',
  'pokusan',
  'legios',
  'britzigel',
  'snomnom',
  'mottineva',
  'humanolith',
  'kubuin',
  'servol',
  'morpeko',
  'kupfanti',
  'patinaraja',
  'lectragon',
  'pescragon',
  'pescryodon',
  'duraludon',
  'grolldra',
  'phandra',
  'katapuldra',
  'zacian',
  'zamazenta',
  'endynalos',
  'dakuma',
  'wulaosu',
  'zarude',
  'regieleki',
  'regidrago',
  'polaross',
  'phantoross',
  'coronospa',
  'damythir',
  'axantor',
  'ursaluna',
  'salmagnis',
  'snieboss',
  'myriador',
  'cupidos',
  'felori',
  'feliospa',
  'maskagato',
  'krokel',
  'lokroko',
  'skelokrok',
  'kwaks',
  'fuentente',
  'bailonda',
  'ferkuli',
  'fragrunz',
  'tarundel',
  'spinsidias',
  'micrick',
  'lextremo',
  'pamo',
  'pamamo',
  'pamomamo',
  'zwieps',
  'famieps',
  'hefel',
  'backel',
  'olini',
  'olivinio',
  'olithena',
  'krawalloro',
  'geosali',
  'sedisal',
  'saltigant',
  'knarbon',
  'crimanzo',
  'azugladis',
  'blipp',
  'wampitz',
  'voltrel',
  'voltrean',
  'mobtiff',
  'mastifioso',
  'sproxi',
  'affiti',
  'weherba',
  'horrerba',
  'tentagra',
  'tenterra',
  'klibbe',
  'chilingel',
  'halupenjo',
  'relluk',
  'skarabaks',
  'flattutu',
  'psiopatra',
  'forgita',
  'tafforgita',
  'granforgita',
  'schligda',
  'schligdri',
  'adebom',
  'normifin',
  'delfinator',
  'knattox',
  'knattatox',
  'mopex',
  'schlurm',
  'lumispross',
  'lumiflora',
  'gruff',
  'friedwuff',
  'flaminkno',
  'flaniwal',
  'kolowal',
  'agiluza',
  'heerashai',
  'nigiragi',
  'epitaff',
  'suelord',
  'farigiraf',
  'dummimisel',
  'gladimperio',
  'riesenzahn',
  'brüllschweif',
  'wutpilz',
  'flatterhaar',
  'kriechflügel',
  'sandfell',
  'eisenrad',
  'eisenbündel',
  'eisenhand',
  'eisenfalter',
  'eisendorn',
  'frospino',
  'cryospino',
  'espinodon',
  'gierspenst',
  'monetigo',
  'chongjian',
  'baojian',
  'dinglu',
  'yuyu',
  'donnersichel',
  'eisenkrieger',
  'koraidon',
  'miraidon'
];
